var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('menu-layout',{attrs:{"loading":_vm.loading,"title":_vm.$t('model_page.title'),"subtitle":_vm.$t('model_page.subtitle')}},[_c('row12',[_c('train-configs-and-models')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }